import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../AuthContext";
import AgreementsGrid from "./AgreementsGrid";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import {
  getAgreementList,
  updateAgreementInfo,
} from "../services/agreementServices";
//import AgmEquiplmentDialog from "./AgmEquiplmentDialog";
import AgmConfirmEquimentsDialog from "./AgmConfirmEquimentsDialog";
import NewAgreementDialog from "./NewAgreementDialog";
import DuplicateAgreementCreateDialog from "./DuplicateAgreementCreateDialog";
import AgreementEquimentDialog from "./AgreementEquimentDialog";
import { getEquipmentTypes } from "../services/equipmentService";
import { sendAgreementEmail } from "../services/emailNotifcationService";

const AgreementList = ({
  dealer,
  showDealer = false,
  displayType,
  dealerId,
  filterAgreementId,
  tenant,
  businessUnits,
}) => {
  console.log("AgreementList displayType : ", displayType);
  console.log(
    `AgreementList displayType dealerid:${dealerId}, filteredAgreementId : ${filterAgreementId}`
  );
  const { setCtxStEquipments, setCtxEquipmentTypes, APP_ENV, user } =
    useContext(AuthContext);
  const [agreementList, setAgreementList] = useState([]);
  const [selectedAgreementId, setSelectedAgreementId] = useState(null);
  const [syncAgreementId, setSyncAgreementId] = useState(null);
  const [optype, setOptype] = useState("");
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [disType] = useState(displayType);
  const [selectedProductCode, setSelectedProductCode] = useState(null);
  const [selectedPoNumber, setSelectedPoNumber] = useState(null);
  const [openAgmEquiDialog, setOpenAgmEquiDialog] = useState(false);
  const [openAgmDetailsDialog, setOpenAgmDetailsDialog] = useState(false);
  const [openEquSyncDialog, setOpenEquSyncDialog] = useState(false);
  const [agreementListLoading, setAgreementListLoading] = useState(false);
  const [openNewAgreementDialog, setOpenNewAgreementDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [viewMode, setViewMode] = useState(false);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [selectedEmailAgreement, setSelectedEmailAgreement] = useState(null);
  const [emailTo, setEmailTo] = useState("");
  const [emailSending, setEmailSending] = useState(false);
  const [isNameUpdated, setIsNameUpdated] = useState(false);
  const [isEmPhUpdated, setIsEmPhUpdated] = useState(false);
  const [isAddressUpdated, setIsAddressUpdated] = useState(false);

  //console.log("Agreement list dealer data:", dealer);
  //console.log("Agreement list group :", group);
  useEffect(() => {
    setSelectedDealer(dealer);
    //setDisType(displayType);
  }, [dealer.dealerId]);
  // useEffect(() => {
  //   if (selectedDealerId > 0) {
  //     loadDealerList(selectedDealerId);
  //   }
  // }, [dealerId]);

  useEffect(() => {
    getEquipmentTypes()
      .then((res) => {
        console.log("equipment types list response : ", res);
        setCtxEquipmentTypes(res.data);
      })
      .catch((error) => {
        console.log("error fetching equipment types : ", error);
      });
  }, []);

  const loadDealerList = (_dealerId) => {
    console.log("Loading Agreement List for dealer : ", _dealerId);
    setAgreementList([]);
    setAgreementListLoading(true);
    getAgreementList(_dealerId)
      .then(
        (res) => {
          console.log("Agreement list response :", res);
          const data = APP_ENV === "Development" ? res.data.body : res.data;
          console.log("Adgreement List :", data);
          const statusCode = res.status;
          if (statusCode === 200 && data.length > 0) {
            if (filterAgreementId && filterAgreementId > 0) {
              const tempData = data.filter((d) => d.id === filterAgreementId);
              setAgreementList(tempData);
            } else {
              console.log("setting agreement list ", data);
              setAgreementList(data);
            }
          }
          setAgreementListLoading(false);
        },
        (err) => {
          console.log("Unable to load data from agreement service", err);
          setAgreementListLoading(false);
        }
      )
      .catch((err) => {
        console.error("Get Agreements List Internal Server error", err);
        setAgreementListLoading(false);
      });
  };

  useEffect(() => {
    //const dealerId = selectedDealer ? selectedDealer.id : 0;
    if (disType === "admin") {
      console.log("loading agreement list from admin user");
      loadDealerList(0);
    } else {
      console.log("display type :", disType);
      if (dealer) {
        loadDealerList(dealer.dealerId);
      }
    }
  }, [dealer.dealerId, disType]);

  const handleOpenEquiDialog = (param, type) => {
    console.log("AgreementList selected agreement :", param);
    setCtxStEquipments([]);
    setSelectedAgreementId({
      ...param,
      address: param.location,
      customer: param.customerName,
    });
    setSelectedProductCode(param.productCode);
    setSelectedPoNumber(param.poNumber ? param.poNumber : param.invoiceId);
    setOptype(type);
    setOpenAgmEquiDialog(true);
  };

  const handleOpenDuplicateAgreementDialog = (param) => {
    console.log("AgreementDetails selected agreement :", param);
    if (param.ctype && param.ctype === "newaggclose") {
      handleNewAgreementDialogClose();
    }
    setSelectedAgreementId(param);
    setOpenAgmDetailsDialog(true);
    setCtxStEquipments([]);
  };

  const handleAgmEquiDialogClose = (data) => {
    console.log("close called :", data);
    if (data === "success") {
      console.log("reloading dealers");
      const dealerId = selectedDealer ? selectedDealer.dealerId : 0;
      console.log("reloading dealers:", dealerId);
      loadDealerList(dealerId);
    }
    setOpenAgmEquiDialog(false);
    setOptype("");
    setSelectedPoNumber(null);
    setSelectedProductCode(null);
    setSelectedAgreementId(null);
    setCtxStEquipments([]);
  };

  const handleOpenEquSyncDialog = (param, isViewMode = false) => {
    console.log("Sync Equipment agreement :", param);
    console.log("isViewMode :", isViewMode);
    setViewMode(isViewMode);
    setSyncAgreementId({
      ...param,
      address: param.location,
      customer: param.customerName,
    });
    setSelectedProductCode(param.productCode);
    setSelectedPoNumber(param.poNumber);
    setOpenEquSyncDialog(true);
  };

  const handleEquSyncDialogClose = (data) => {
    console.log("sync dialog close  called :", data);
    if (data === "success") {
      console.log("reloading dealers");
      const dealerId = selectedDealer ? selectedDealer.dealerId : 0;
      console.log("reloading dealers:", dealerId);
      loadDealerList(dealerId);
    }
    setSyncAgreementId(null);
    setCtxStEquipments([]);
    setOpenEquSyncDialog(false);
  };

  const handleCloseAgmDetailsDialog = (data) => {
    console.log("close called :", data);
    if (data === "success") {
      console.log("reloading dealers");
      const dealerId = selectedDealer ? selectedDealer.dealerId : 0;
      console.log("reloading dealers:", dealerId);
      loadDealerList(dealerId);
    }
    setSelectedAgreementId("");
    setOpenAgmDetailsDialog(false);
  };

  const handleEquipmentEdit = (data) => {
    console.log("handleEquipmentEdit === ", data);
    setOpenEquSyncDialog(false);
    setSyncAgreementId("");
    setSelectedAgreementId(data);
    setOptype("update");
    setOpenAgmEquiDialog(true);
    setSelectedPoNumber(data?.invoiceNumber);
  };

  const handleNewAgreementDialogClose = (data) => {
    console.log("close called :", data);
    if (data === "success") {
      console.log("reloading dealers");
      const dealerId = selectedDealer ? selectedDealer.dealerId : 0;
      console.log("reloading dealers:", dealerId);
      loadDealerList(dealerId);
    }
    setOpenNewAgreementDialog(false);
  };

  const handleSendEmail = (row) => {
    console.log('handleSendEmail :', row);
    setSelectedEmailAgreement(row);
    setEmailTo(row.emailAddress || "");
    setOpenEmailDialog(true);
  };

  const handleEmailSend = (subject, body) => {
    const dealerInfo = JSON.parse(localStorage.getItem("dealer") || "{}");
    console.log('handleEmailSend DealerInfo :', dealerInfo);
    const payload = {
      emailTo,
      subject,
      customerName: selectedEmailAgreement.customerName,
      pdfUrl: selectedEmailAgreement.comments,
      jbwAgreementId: selectedEmailAgreement.jbwAgreementId,
      dealerId: dealerInfo.dealerId || dealerInfo.id || "",
      dealerName: dealerInfo.dealerName || dealerInfo.name || "",
      address1: dealerInfo.addressline_1,
      city: dealerInfo.city,
      state: dealerInfo.state,
      zipcode: dealerInfo.zipcode,
    };
    console.log("Sending email payload:", payload);
    setEmailSending(true);
    sendAgreementEmail(payload)
      .then((res) => {
        console.log("Email send response:", res);
        setOpenEmailDialog(false);
      })
      .catch((err) => {
        console.error("Email send error:", err);
      })
      .finally(() => {
        setEmailSending(false);
      });
  };

  const handleOpenNewAgreementDialog = () => {
    setCtxStEquipments([]);
    setOpenNewAgreementDialog(true);
  };

  const trmRef = useRef();
  const handleScrolleUp = () => {
    trmRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handleAgreementInfoUpdate = (agreementId, info) => {
    console.log(
      "AgreementList Agreement info update called :",
      agreementId,
      info
    );
    if (info.infoType === "name") {
      const infoData = {
        infoType: info.infoType,
        firstName: info.firstName,
        lastName: info.lastName,
        user: user.name,
      };
      updateAgreementInfo(agreementId, infoData)
        .then((res) => {
          console.log("name update response :", res);
          if (res.status === 200) {
            console.log("updating name in agreement");
            setAgreementList((oldList) => [
              ...oldList.map((agreement) =>
                agreement.id === agreementId
                  ? {
                    ...agreement,
                    customerName: info.firstName + " " + info.lastName,
                    firstName: info.firstName,
                    lastName: info.lastName,
                  }
                  : { ...agreement }
              ),
            ]);
            setSelectedAgreementId((oldAg) => ({
              ...oldAg,
              customerName: info.firstName + " " + info.lastName,
              firstName: info.firstName,
              lastName: info.lastName,
            }));
            setIsNameUpdated(!true);
          }
        })
        .catch((error) => {
          console.log("error : ", error);
          setIsNameUpdated(!true);
        });
    } else if (info.infoType === "emph") {
      const infoData = {
        infoType: info.infoType,
        emailAddress: info.emailAddress,
        phoneNumber: info.phoneNumber,
        user: user.name,
      };
      updateAgreementInfo(agreementId, infoData)
        .then((res) => {
          if (res.status === 200) {
            setAgreementList((oldList) => [
              ...oldList.map((agreement) =>
                agreement.id === agreementId
                  ? {
                    ...agreement,
                    emailAddress: info.emailAddress,
                    phoneNumber: info.phoneNumber,
                  }
                  : { ...agreement }
              ),
            ]);
            setSelectedAgreementId((oldAg) => ({
              ...oldAg,
              emailAddress: info.emailAddress,
              phoneNumber: info.phoneNumber,
            }));
            setIsEmPhUpdated(!true);
          }
        })
        .catch((error) => {
          console.log("error : ", error);
          setIsEmPhUpdated(!true);
        });
    } else if (info.infoType === "address") {
      const infoData = {
        infoType: info.infoType,
        addressLine1: info.addressLine1,
        addressLine2: info.addressLine2,
        unit: info.unit,
        city: info.city,
        state: info.state,
        zipcode: info.zipcode,
        user: user.name,
      };
      updateAgreementInfo(agreementId, infoData)
        .then((res) => {
          if (res.status === 200) {
            setAgreementList((oldList) => [
              ...oldList.map((agreement) =>
                agreement.id === agreementId
                  ? {
                    ...agreement,
                    addressLine1: info.addressLine1,
                    addressLine2: info.addressLine2,
                    city: info.city,
                    unit: info.unit,
                    state: info.state,
                    zipcode: info.zipcode,
                    location: getLocation(
                      info.addressLine1,
                      (info.unit !== "null" && info.unit !== null ? info.unit : info.addressLine2),
                      info.city,
                      info.state,
                      info.zipcode
                    ),
                  }
                  : { ...agreement }
              ),
            ]);
            setSelectedAgreementId((oldAg) => ({
              ...oldAg,
              addressLine1: info.addressLine1,
              addressLine2: info.addressLine2,
              city: info.city,
              state: info.state,
              zipcode: info.zipcode,
              location: getLocation(
                info.addressLine1,
                info.addressLine2,
                info.city,
                info.state,
                info.zipcode
              ),
            }));
            setIsAddressUpdated(!true);
          }
        })
        .catch((error) => {
          console.log("error : ", error);
          setIsAddressUpdated(!true);
        });
    } else if (info.infoType === "locationAddress") {
      console.log("locationAddress info:", info);
      const infoData = {
        infoType: info.infoType,
        locationId: info.locationId,
        addressLine1: info.street,
        addressLine2: info.unit,
        city: info.city,
        state: info.state,
        zipcode: info.zipcode,
        user: user.name,
      };
      console.log("locationAddress  infoData :", infoData);
      updateAgreementInfo(agreementId, infoData)
        .then((res) => {
          if (res.status === 200) {
            setAgreementList((oldList) => [
              ...oldList.map((agreement) =>
                agreement.id === agreementId
                  ? {
                    ...agreement,
                    locationId: info.locationId,
                    addressLine1: info.street,
                    addressLine2: info.unit ? info.unit : '',
                    city: info.city,
                    state: info.state,
                    zipcode: info.zipcode,
                    location: getLocation(
                      info.street,
                      info.unit ? info.unit : '',
                      info.city,
                      info.state,
                      info.zipcode
                    ),
                  }
                  : { ...agreement }
              ),
            ]);
            setSelectedAgreementId((oldAg) => ({
              ...oldAg,
              locationId: info.locationId,
              addressLine1: info.street,
              addressLine2: info.unit ? info.unit : null,
              city: info.city,
              state: info.state,
              zipcode: info.zipcode,
              location: getLocation(
                info.street,
                info.unit ? info.unit : null,
                info.city,
                info.state,
                info.zipcode
              ),
            }));
            setIsAddressUpdated(!true);
          }
        })
        .catch((error) => {
          console.log("error : ", error);
          setIsAddressUpdated(!true);
        });
    }
  };

  const getLocation = (addressLine1, addressLine2, city, state, zipCode) => {
    return `${addressLine1} ${addressLine2 !== null && addressLine2 !== "null" ? ", " + addressLine2 : ""
      }
    ${city !== null && city !== "null" ? ", " + city : ""} ${state !== null && state !== "null" ? ", " + state : ""
      } ${zipCode !== null && zipCode !== "null" ? ", " + zipCode : ""}.`;
  };

  const renderEmailDialog = () => {
    if (!openEmailDialog || !selectedEmailAgreement) return null;
    const dealerInfo = JSON.parse(localStorage.getItem("dealer") || "{}");
    const subject = `Extended Warranty Service Contract - ${selectedEmailAgreement.jbwAgreementId}`;
    const dealerName = dealerInfo.dealerName || dealerInfo.name || "";
    const address = [
      dealerInfo.addressLine1,
      dealerInfo.city,
      dealerInfo.state,
      dealerInfo.zipcode,
    ]
      .filter(Boolean)
      .join(", ");
    const commentsUrl = selectedEmailAgreement.comments || "";
    //const body = `Dear ${selectedEmailAgreement.customerName || ""},\n\nThank you for choosing ${dealerName}.\n\nDealer: ${dealerName}\nAddress: ${address}${commentsUrl ? `\n\nClick here to download your agreement: ${commentsUrl}` : ""}`;
    const body = `Dear ${selectedEmailAgreement.customerName || ""},\n\nThank you for choosing ${dealerName}.\n\n${commentsUrl ? `\n\nClick here to download your agreement: ${commentsUrl}` : ""}`;
    return (
      <Dialog
        open={openEmailDialog}
        onClose={() => setOpenEmailDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Send Email</DialogTitle>
        <DialogContent>
          <TextField
            label="Customer Name"
            fullWidth
            value={selectedEmailAgreement.customerName || ""}
            InputProps={{ readOnly: true }}
            margin="normal"
          />
          <TextField
            label="Customer Email"
            fullWidth
            value={emailTo}
            onChange={(e) => setEmailTo(e.target.value)}
            margin="normal"
          />
          <TextField
            label="Subject"
            fullWidth
            value={subject}
            InputProps={{ readOnly: true }}
            margin="normal"
          />
          <TextField
            label="Body"
            fullWidth
            multiline
            rows={5}
            value={body}
            InputProps={{ readOnly: true }}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEmailDialog(false)} disabled={emailSending}>Close</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={emailSending || !emailTo}
            onClick={() => handleEmailSend(subject, body)}
          >
            {emailSending ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      {renderEmailDialog()}
      {/* {Duplicate Agreement} */}
      {openAgmDetailsDialog && (
        <DuplicateAgreementCreateDialog
          openAgmDetailsDialog={openAgmDetailsDialog}
          agreementId={selectedAgreementId}
          onCloseAgmDetailsDialog={handleCloseAgmDetailsDialog}
          dealer={selectedDealer}
        />
      )}
      {/* {openAgmEquiDialog && (
        <AgmEquiplmentDialog
          onClose={handleAgmEquiDialogClose}
          open={openAgmEquiDialog}
          agreementId={selectedAgreementId}
          productCode={selectedProductCode}
          poNumber={selectedPoNumber}
          optype={optype}
          userName={user.name}
        />
      )} */}
      {/* {New and Edit Equipment} */}
      {openAgmEquiDialog && selectedAgreementId && (
        <AgreementEquimentDialog
          onClose={handleAgmEquiDialogClose}
          open={openAgmEquiDialog}
          agreement={selectedAgreementId}
          productCode={selectedProductCode}
          poNumber={selectedPoNumber}
          optype={optype}
          onAgreementInfoUpdate={handleAgreementInfoUpdate}
          isEmPhUpdated={isEmPhUpdated}
          isNameUpdated={isNameUpdated}
          isAddressUpdated={isAddressUpdated}
          onPlanChange={(maxUnits, description, productCode) => {
            setSelectedAgreementId((agm) => {
              return {
                ...agm,
                equipmentUnits: maxUnits,
                productDescription: description,
                productCode: productCode,
              };
            });
          }}
          onEnableCustomerNameEdit={(status) => {
            setIsNameUpdated(status);
          }}
          onEnablePhoneEmailEdit={(status) => {
            setIsEmPhUpdated(status);
          }}
          onEnableLocationEdit={(status) => {
            setIsAddressUpdated(status);
          }}
          dealer={selectedDealer}
        />
      )}
      {/* {Sync Equipment} */}
      {openEquSyncDialog && (
        <AgmConfirmEquimentsDialog
          onClose={handleEquSyncDialogClose}
          open={openEquSyncDialog}
          agreementId={syncAgreementId}
          onEdit={handleEquipmentEdit}
          viewMode={viewMode}
        />
      )}

      {/* {New Agreement} */}

      {openNewAgreementDialog && (
        <NewAgreementDialog
          open={openNewAgreementDialog}
          onClose={handleNewAgreementDialogClose}
          dealer={dealer}
          onCreateDuplicateAgreement={handleOpenDuplicateAgreementDialog}
          tenant={tenant}
        />
      )}

      <Grid container ref={trmRef}>
        <Grid item xs={12}>
          <AgreementsGrid
            agreementList={agreementList}
            dealer={dealer}
            showDealer={showDealer}
            openEquimentDialog={handleOpenEquiDialog}
            openEquConfirmDialog={handleOpenEquSyncDialog}
            openDuplicateAgreementDialog={handleOpenDuplicateAgreementDialog}
            showLoading={agreementListLoading}
            onNewAgreement={handleOpenNewAgreementDialog}
            onSendEmail={handleSendEmail}
            tenant={tenant}
            businessUnits={businessUnits}
            onScrolleUp={handleScrolleUp}
            page={page}
            setPage={setPage}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AgreementList;
